<template>
  <div class="bg-genius m-0 p-10" style="width:100vw;height:100vh;text-align:left">
    <div class="w-1/2 bg-white shadow-20 p-10" style="margin:0 auto">
      <img v-if="logo" :src="logo" style="height: 150px" class="p-6"/>
      Unfortunately Internet Explorer is not supported by this customer portal.
      <br />
      <br />Please use to one of the browsers below:
      <br/>
      <br /><a href="https://www.microsoft.com/en-us/edge"><div class="browser"><img src="https://i.imgur.com/VKVjhGf.png" class="logo"/>Edge</div></a>
      <br /><a href="https://www.google.com/chrome/"><div class="browser"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Google_Chrome_icon_%28September_2014%29.svg/1200px-Google_Chrome_icon_%28September_2014%29.svg.png" class="logo">Chrome</div></a>
      <br /><a href="https://www.mozilla.org/en-GB/firefox/new/"><div class="browser"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Firefox_logo%2C_2019.svg/1200px-Firefox_logo%2C_2019.svg.png" class="logo">Firefox</div></a>
      <br />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: "",
    };
  },

  mounted() {
    this.getLogo()
  },

  methods:{
    getLogo(){
      var url = document.location.hostname;
      var images = require.context("../assets/logos/", false, /\.png$/);
      var tenant = "";
      if (url.includes("smfmotor")) tenant = "smf"
      this.logo = !tenant ? null : images("./" + tenant + ".png");
    }
  }
};
</script>
<style scoped>
.logo{
    height:64px;
    float:left;
    margin-right: 20px
}

.browser{
    display:flex;
    align-items:center;
    justify-content: flex-start;
}
</style>